import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IhmNotificationMessage } from '../ihm-notifications/interfaces/ihm-notifications.interface';
import { AdPlusHeaderLink } from './adplus-header-link.interface';
import { IhmLink } from '../ihm-link/ihm-link.interface';

@Component({
  selector: 'adplus-header',
  templateUrl: './adplus-header.component.html',
  styleUrls: ['./adplus-header.component.scss']
})
export class AdPlusHeaderComponent {
  @Input() username: string = 'Tester';
  @Input() userEmail: string = '';
  @Input() showIcons: boolean = true;
  @Input() dropdown: boolean = false;
  @Input() appName: string = 'App Name';
  @Input() appTheme: string;
  @Input() notifications: IhmNotificationMessage[];

  @Input() headerLinks: AdPlusHeaderLink[] = [];
  @Input() appLinks: IhmLink[] = [];

  constructor(private router: Router) {}

  logout(): void {
    this.router.navigateByUrl('/logout');
  }

  toggleDropdown(): void {
    this.dropdown = !this.dropdown;
  }

  @HostListener('document:click', ['$event']) clickedOutsideDropBox($event) {
    if (this.dropdown && !$event.target.className.includes('user-image')) {
      this.dropdown = false;
    }
  }

  hasNotificationMessages(): boolean {
    return this.notifications && this.notifications.length > 0;
  }
}
